module.exports = __webpack_public_path__ + "static/media/solera-audatex-logo-black.fb58e9e2.png";